import React from "react";

export default function Terms() {

    return (
        <div className="w-full min-h-screen bg-white text-black px-6 py-8 md:px-16 lg:px-24">

            <div className="mb-6 leading-relaxed text-[16px]">
                <p>
                    Website:{" "}
                    <a
                        href="https://redvideochat.live/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-red-500"
                    >
                        https://redvideochat.live/
                    </a>
                </p>
                <p>
                    Privacy Policy:{" "}
                    <a
                        href="/privacy"
                        className="text-red-500"
                    >
                        https://redvideochat.live/privacy
                    </a>
                </p>
                <p className="mt-1">Updated at: 01.12.2025</p>
            </div>

            {/* TERMS CONTENT */}
            <div className="leading-7 text-[16px] whitespace-pre-line">

                <p>
                    Please Great carefully the following provisions of this TERMS OF USE
                    (“TERMS OF USE”). This is a legal agreement between you and Loka
                    Digital Medya Reklamcılık ve Teknoloji AŞ and various & next versions
                    including web-based version "Red Web" (All Red services shall
                    collectively referred to as Red) regarding the use of the Red
                    software programs and related documentation being installed by you on
                    your device (the “Software”). By downloading the Software and/or using
                    any of the services enabled by the Software (the “Services”), YOU
                    ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY
                    THE FOLLOWING TERMS AND CONDITIONS (INCLUDING ANY ADDITIONAL
                    GUIDELINES AND FUTURE MODIFICATIONS) AND BY Red's PRIVACY POLICY,
                    WHICH IS INCORPORATED HEREIN BY REFERENCE AND CAN BE FOUND AT
                    HTTPS://REDVIDEOCHAT.LIVE/PRIVACY. IF AT ANY TIME YOU DO NOT
                    AGREE TO THESE TERMS AND CONDITIONS OF USE, YOU MAY NOT USE THE
                    SOFTWARE OR SERVICES AND MUST IMMEDIATELY TERMINATE YOUR USE OF THE
                    SOFTWARE AND ALL SERVICES.
                </p>

                <br />

                <p className="font-semibold">1. Acknowledgment.</p>
                <p>
                    This paragraph is intended to apply to you if you have downloaded the
                    Software from the app marketplaces such as the Apple App Store and the
                    Google Play. Red and you acknowledge that this Terms of Use is
                    concluded between Red and you only, and not with the app
                    marketplaces, and as between Red and the marketplaces, Red, not the
                    marketplaces, is solely responsible for the Software and the content
                    thereof. This Terms of Use is not intended to provide for usage rules
                    for the Software and Services that are less restrictive than the Usage
                    Rules set forth for Licensed Applications in, or otherwise be in
                    conflict with, the Terms of Service of the app marketplaces as of the
                    date hereof (which you further acknowledge you have had the
                    opportunity to review).
                </p>

                <br />

                <p className="font-semibold">2. License Grant.</p>
                <p>
                    Subject to your compliance with the terms and conditions set out in this Terms of Use,
                    Red grants you a personal, limited, non-commercial, non-exclusive, non-sublicensable,
                    non-assignable, revocable license to download, install and use one (1) copy of the
                    Software, in object code format, only on your personal computer or mobile device
                    (the “Device”) for the sole purpose of personally using the Red application and any
                    other applications that may be explicitly authorized by Red for use through use of the
                    Software. If you have downloaded the Software from the Apple App Store or Google Play,
                    use is permitted by the Usage Rules set forth in the Terms of Service of the respective
                    store as of the date hereof.
                </p>

                <br />

                <p className="font-semibold">3. Ownership.</p>
                <p>
                    The Software is protected by copyright laws and international copyright
                    treaties, as well as other intellectual property laws and treaties. It includes
                    trade secrets and confidential information proprietary to Red, and you agree
                    to take all necessary actions to maintain the confidentiality of such
                    information. All ownership rights in the Software and Services—including
                    related documentation, updates, releases, modifications, and enhancements—belong
                    solely to Red and its licensors, including all intellectual property rights
                    therein. The Software is licensed, not sold, and no title or ownership passes
                    to you. No implied license, right, or interest is granted except those
                    expressly outlined herein. Red reserves all rights in the Software and
                    Services not explicitly granted to you.
                </p>

                <br />

                <p className="font-semibold">4. Restrictions</p>
                <p>
                    You are granted only a license to use the object-code version of the Software.
                    You shall not: (i) Copy, modify, adapt, translate into any language,
                    distribute, or create derivative works of the Software or any Services.
                    (ii) Sublicense, sublease, lease, lend, assign, sell, license, distribute,
                    rent, export, re-export, or otherwise transfer rights in the Software or
                    Services. (iii) Attempt to reconstruct, identify, or discover any source code,
                    underlying ideas, user-interface techniques, or algorithms of the Software or
                    any Services through reverse engineering, decompiling, disassembling, or any
                    other method. (iv) Remove, obscure, or alter any copyright notices or
                    proprietary notices contained in or connected to the Software or Services.
                    (v) Use the Software or Services to create or distribute viruses or to
                    circumvent copyright protection or other digital rights management mechanisms.
                </p>

                <br />

                <p className="font-semibold">5. Additional Restrictions</p>
                <p>
                    You further represent that you shall not: (i) Use the Software or Services for
                    any illegal or unauthorized purpose. (ii) Use the Software or Services in any
                    manner that could damage, disable, overburden, or impair any part of the
                    Services. (iii) Transmit worms, viruses, or any code of a destructive nature.
                    (iv) Display, transmit, or share any content consisting of text, sounds, audio,
                    pictures, photos, videos, or any type of materials (“Content”) that is hateful,
                    threatening, pornographic, obscene, abusive, racially or ethnically offensive,
                    libelous, defamatory, or otherwise objectionable. (v) Encourage conduct that
                    would be a criminal offense or result in civil liability. (vi) Attempt to hack,
                    destabilize, or adapt Red's website, the Software (including source code),
                    or any Services. (vii) Alter another website to falsely imply affiliation with
                    Red. (viii) Use or access the Services in any way other than the interface
                    provided by Red.
                </p>

                <br />

                <p className="font-semibold">6. Your Utilization of Your Device</p>
                <p>
                    If your use of the Software or Services relies on bandwidth owned or controlled
                    by a third party, you acknowledge and agree that: Your license to use the
                    Software requires consent from the relevant third-party owner of that bandwidth
                    or network. By using the Software, you warrant that you have obtained such
                    consent. You warrant that you own the Device on which you are downloading the
                    Software, or that you have legal authority to use that Device. You agree to
                    ensure that any person who uses the Software or Services on your Device does
                    so according to these Terms of Use. You must delete the Software from the
                    Device if you sell the Device or otherwise lose the right to control its use.
                </p>

                <br />

                <p className="font-semibold">7. Content</p>
                <p>
                    Content transmitted through the Software or Services is the sole responsibility
                    of the individual from whom such Content originated. By using the Software or
                    Services, you understand and acknowledge the following: You may be exposed to
                    Content that is offensive, harmful to minors, indecent, or otherwise
                    objectionable. Red does not endorse any Content transmitted or displayed
                    through the Software or Services. Red disclaims all liability in connection
                    with any and all Content. You release and discharge Red and its affiliates
                    ("Red Parties") from any and all claims, demands, or damages arising out of
                    or relating to any Content.
                </p>

                <br />

                <p className="font-semibold">8. Your Content.</p>
                <p>
                    You acknowledge and agree that you are solely responsible for any Content
                    that you transmit or display through the Software or Services and that Red
                    (and Apple or Google if you downloaded the Software from the App Store or
                    Google Play) is not responsible to you or any third party in connection
                    with any Content. You further agree to pay for all royalties, fees, and any
                    other monies owing any person by reason of any of your Content. In addition,
                    you represent and warrant that: (a) you are the creator and owner of or have
                    the necessary rights to transmit or display the Content; and (b) the Content
                    you transmit or you display does not and will not: (i) infringe, violate, or
                    misappropriate any third-party right, including any copyright, trademark,
                    patent, trade secret, moral right, privacy right, right of publicity, or any
                    other intellectual property or proprietary right, or (ii) slander, defame,
                    libel, or invade the right of privacy, publicity or other property rights of
                    any other person. VIOLATORS OF THESE THIRD-PARTY RIGHTS MAY BE SUBJECT TO
                    CRIMINAL AND CIVIL LIABILITY. Red RESERVES ALL RIGHTS AND REMEDIES AGAINST
                    ANYONE Red VIOLATES ANY OF THE PROVISIONS OF THIS TERMS OF USE.
                </p>

                <br />

                <p className="font-semibold">9. Third Parties</p>
                <p>
                    The Software may be incorporated into, and may incorporate itself, software
                    and other technology owned and controlled by third parties. Any such
                    third-party software or technology that is incorporated in the Software
                    falls under the scope of this Agreement.
                </p>

                <br />

                <p className="font-semibold">10. New Versions of the Software</p>
                <p>
                    Red, in its sole discretion, reserves the right to add additional features
                    or functions, or to modify or provide programming fixes, updates, and upgrades
                    to the Software or Services. Red has no obligation to make available to you
                    any additional features or functions or any modifications, updates, support,
                    maintenance, or subsequent versions of the Software or any of the Services.
                    You may have to agree to a renewed version of the Terms of Use in the event
                    you want to download, install, or use any additional features or functions or
                    any modifications, updates, or new versions of the Software. You acknowledge
                    that Red may automatically issue additional features, functions,
                    modifications, updates, or upgraded versions of the Software and may modify,
                    update, or upgrade the version of the Software you are using or have installed
                    on your Device. You hereby agree that your Device may automatically request
                    and/or receive such modifications, upgrades, or updates.
                </p>

                <br />

                <p className="font-semibold">11. Third Party Fees</p>
                <p>
                    For particular Devices, Red may ask your permission to use your native SMS
                    application to deliver messages or invitations to people who are not
                    registered users of the Services and with whom you choose to communicate.
                    Some of these services may charge additional fees.
                </p>

                <br />

                <p className="font-semibold">12. Eligibility</p>
                <p>
                    The license to use the Software and Services is not valid in any jurisdiction
                    where prohibited. The Software and Services are intended solely for users who
                    are eighteen (18) years of age or older, and any registration, use, or access
                    to the Software or Services by anyone under 18 is unauthorized, unlicensed,
                    and in violation of these Terms of Use. Red may terminate your account,
                    delete any content or information you have posted on the Services, and/or
                    prohibit you from using or accessing the Software or Services (or any portion,
                    aspect, or feature of the Services) for any reason or for no reason, at any
                    time in its sole discretion, with or without notice, including if it believes
                    that you are under 18. If you are under 18 years of age, you may use the
                    Software and Services only if you are an emancipated minor or possess legal
                    parental or guardian consent, and are fully able and competent to enter into
                    and abide by the provisions set forth in these Terms of Use.
                </p>

                <br />

                <p className="font-semibold">13. No Access to Emergency Services.</p>
                <p>
                    The Software and Services are not intended to support or carry emergency
                    calls to any type of hospitals, law enforcement agencies, medical care unit
                    or any other kind of services that connect a user to emergency services
                    personnel or public safety answering points pursuant to applicable local
                    and or national regulatory requirements (“Emergency Services”). There are
                    important differences between traditional telephone services and the
                    Software and Services. You acknowledge and agree that: (i) Red is not
                    required to offer access to Emergency Services under any applicable local
                    and/or national rules, regulations or law; (ii) it is your responsibility
                    to purchase, separately from the Software, traditional wireless (cellular)
                    or fixed line telephone services that offer access to Emergency Services,
                    and (iii) Red is not a replacement for your primary telephone service.
                </p>

                <br />

                <p className="font-semibold">14. Prevention of Unauthorized Use.</p>
                <p>
                    Red reserves the right to exercise whatever lawful means it deems necessary
                    to prevent unauthorized use of the Software or Services, including, but not
                    limited to, technological barriers, IP mapping, and directly contacting your
                    wireless (cellular) carrier regarding such unauthorized use.
                </p>

                <br />

                <p className="font-semibold">15. License Grant to Red.</p>
                <p>
                    You hereby authorize Red to collect and use the address books, contact lists,
                    and unique phone identifiers (IMEI, UDID, or other) contained in the Devices
                    to which you have downloaded the Software for purposes of your use of the
                    Services.
                </p>

                <br />

                <p className="font-semibold">16. Premium and all kind of paid contents & item Services.</p>
                <p>
                    From time to time, Red may provide additional features and/or Services that
                    you pay for (“Premium and all kind of paid contents & item Services”).
                    Red may also offer from time to time in its sole discretion, certain Premium
                    and all kind of paid contents & item Services for free, whether for a trial
                    period or otherwise. Unless expressly stated otherwise, references in this
                    Terms of Use to the Services include the Premium and all kind of paid contents
                    & item Services.
                </p>

                <br />

                <p className="font-semibold">17. Payments for Premium and all kinds of paid contents & item Services.</p>
                <p>
                    The Premium and all kinds of paid contents & item Services may be offered on a
                    subscription basis, per usage basis, or as otherwise described at the time of
                    your purchase, and may be payable in advance, in arrears, per usage, or as
                    otherwise described at the time of your purchase. If you purchase any Premium
                    and all kinds of paid contents & item Services, you hereby agree to pay all
                    charges to your account, including applicable taxes, in accordance with billing
                    terms in effect at the time the charges are payable and whether charged by Red
                    or the online application store from which you downloaded the Software
                    (the “Application Store”). You agree to abide by any relevant terms of service
                    or other legal agreement that governs your use of a given payment processing
                    service and/or method. If you purchase Premium and all kinds of paid contents
                    & item Services on a subscription basis, you acknowledge and agree that this
                    is a recurring payment and payments shall be made by the payment method and
                    payment intervals you have selected, until the subscription for the Premium
                    and all kinds of paid contents & item Services is terminated. You agree that
                    if you purchase Premium and all kinds of paid contents & item Services through
                    an Application Store, all payment-related questions, issues, disagreements,
                    and/or disputes shall be handled in accordance with the terms of service or
                    other legal agreement that governs your use of a given payment processing
                    service and/or method, and in no event will Red have any responsibility in
                    connection with any of the foregoing.
                </p>

                <br />

                <p className="font-semibold">18. Refunds.</p>
                <p>
                    You may request a full refund for any Premium and all kinds of paid contents
                    & item Service purchased from an Application Store if permitted by, and
                    pursuant to the refund rules of, the Application Store. Exceptions: 1) Refunds
                    are not available to users banned by Red and its community. 2) Full refunds are
                    not available for partially-used purchases.
                </p>

                <br />

                <p className="font-semibold">19. Termination by You</p>
                <p>
                    You may terminate your use of the Services at any time by uninstalling and
                    deleting the Software from all of your Devices. If you have subscribed to any
                    Premium and all kinds of paid contents & item Services, you agree that you are
                    solely responsible for directly terminating all payment obligations you may
                    have with any Application Store and/or payment processing service in connection
                    with the Premium and all kinds of paid contents & item Services.
                </p>

                <br />

                <p className="font-semibold">20. Termination by Red</p>
                <p>
                    Without limiting any other remedies, Red may limit, suspend, discontinue or
                    terminate this Terms of Use and/or your use of all or any part of the Software
                    and/or Services, with immediate effect, automatically, with or without notice
                    and without recourse to the courts, for any reason or for no reason, including
                    without limitation if Red believes that you are (i) in breach of any of the
                    terms of this Terms of Use, (ii) creating problems or legal liabilities
                    (actual or potential), (iii) delinquent with respect to any charges due for a
                    Premium and all kind of paid contents & item Service, (iv) infringing a third
                    party’s intellectual property rights, or (v) engaging in fraudulent, immoral
                    or illegal activities. You agree that Red is under no obligation to provide
                    the Services, including without limitation any Premium and all kind of paid
                    contents & item Services, and that no Red Party shall be liable to you or to
                    any other party for any limitation, suspension, discontinuance, termination or
                    modification of the Software and/or any of the Services.
                </p>

                <br />

                <p className="font-semibold">21. Storage of Content</p>
                <p>
                    Subject to the terms and conditions of this Terms of Use, Red will use
                    reasonable efforts to store your Content, if any, in connection with your use
                    of a Premium and all kind of paid contents & item Service if such storage is a
                    feature provided with the Premium and all kind of paid contents & item Service.
                    You acknowledge and agree that Red shall have no responsibility for the loss,
                    deletion, or destruction of any Content, including any stored Content and that
                    no Red Party is under any obligation to preserve, provide access to or return
                    to you any Content. In addition, you further acknowledge and agree that, if you
                    have elected to use a Premium and any kind of paid contents & item Service that
                    includes the storage of Content and you are not active on the Premium and any
                    kind of paid contents & item Service for thirty (30) days or longer (as
                    determined by Red), Red may delete your Content for any reason, including
                    technical, business or any other reasons.
                </p>

                <br />

                <p className="font-semibold">22. Third-Party Sites, Products and Services; Links</p>
                <p>
                    The Services may include links or references to other websites or services
                    solely as a convenience to our users (“Reference Sites”). Red does not endorse
                    any such Reference Sites. ACCESS AND USE OF REFERENCE SITES, INCLUDING THE
                    INFORMATION, MATERIALS, PRODUCTS, AND SERVICES ON OR AVAILABLE THROUGH
                    REFERENCE SITES IS SOLELY AT YOUR OWN RISK. We encourage you to be aware of
                    when you leave the Services, and to read the terms and conditions and privacy
                    policy of any third-party website or service that you visit. In addition, your
                    correspondence or business dealings with advertisers found on or through the
                    Services are solely between you and such advertiser.
                </p>

                <br />

                <p className="font-semibold">23. Indemnification.</p>
                <p>
                    "YOU HEREBY AGREE TO INDEMNIFY, DEFEND AND HOLD HARMLESS, RED, ITS LICENSORS,
                    ITS PARTNERS, AND ITS AND THEIR RESPECTIVE AFFILIATES, OFFICERS, DIRECTORS,
                    EMPLOYEES, CONTRACTORS AND SUPPLIERS (INCLUDING RED, COLLECTIVELY THE RED
                    PARTIES”), FROM AND AGAINST ANY AND ALL CLAIMS, ACTIONS, LIABILITY, DAMAGES
                    AND COSTS, INCLUDING REASONABLE ATTORNEYS’ FEES INCURRED BY SUCH PARTIES,
                    IN CONNECTION WITH OR ARISING OUT OF (A) YOUR VIOLATION OR BREACH OF ANY TERM
                    OF THIS TERMS OF USE OR ANY APPLICABLE LAW OR REGULATION, WHETHER OR NOT
                    REFERENCED HEREIN, OR (B) YOUR VIOLATION OF ANY RIGHTS OF ANY THIRD PARTY,
                    OR (C) YOUR USE OR MISUSE OF THE SOFTWARE AND/OR ANY OF THE SERVICES, OR (D)
                    YOUR CONTENT OR OTHER COMMUNICATION DISPLAYED OR TRANSMITTED BY MEANS OF THE
                    SOFTWARE AND/OR ANY OF THE SERVICES, OR (E) ANY TAXES RELATED TO YOUR PURCHASE
                    AND/OR USE OF ANY OF THE SERVICES (OTHER THAN TAXES BASED ON THE INCOME OF
                    RED). If you downloaded the Software from the the app marketplaces, you
                    acknowledge that, in the event of any third party claim that the Software or
                    Services or your possession and use of the Software or Services infringes any
                    third party’s intellectual property rights, as between Red and the app
                    marketplaces, Red, not the app marketplaces, will be solely responsible for
                    the investigation, defense, settlement and discharge of any such intellectual
                    property infringement claim. Red reserves the right, at your expense, to
                    assume the exclusive defense and control of any matter for which you are
                    required to indemnify Red, and you agree to cooperate with Red's defense of
                    these claims. You agree not to settle any matter without the prior written
                    consent of Red."
                </p>

                <br />

                <p className="font-semibold">24. Assignment.</p>
                <p>
                    You are not allowed to assign this Terms of Use or any rights or obligations
                    hereunder. Red is allowed at its sole discretion to assign this Terms of Use
                    and any rights hereunder to any third party, without giving of notice.
                </p>

                <br />

                <p className="font-semibold">25. No Warranty.</p>
                <p>
                    The Software and Services are provided to you “AS IS” and “AS AVAILABLE” with
                    no warranties. The Red Parties hereby disclaim all warranties, terms, or
                    conditions, express or implied, either in fact or by operation of law,
                    statutory or otherwise, including, without limitation, warranties, terms or
                    conditions of merchantability, fitness for a particular purpose, satisfactory
                    quality, correspondence with description, title, non-infringement, and accuracy
                    of information generated. ACCORDINGLY, YOU ACKNOWLEDGE AND AGREE THAT THE RED
                    PARTIES (AND IF YOU DOWNLOADED THE SOFTWARE FROM THE APP STORE OR GOOGLE PLAY,
                    APPLE OR GOOGLE) WILL HAVE NO LIABILITY IN CONNECTION WITH OR ARISING FROM YOUR
                    USE OF THE SOFTWARE AND/OR ANY OF THE SERVICES. YOUR ONLY RIGHT OR REMEDY WITH
                    RESPECT TO ANY PROBLEMS OR DISSATISFACTION WITH THE SOFTWARE AND/OR ANY OF THE
                    SERVICES IS TO IMMEDIATELY UNINSTALL THE SOFTWARE AND CEASE USE OF THE SOFTWARE
                    AND ALL SERVICES. You further acknowledge that the Red Parties (and if you
                    downloaded the Software from the App Store or Google Play, Apple or Google)
                    have no obligation whatsoever to furnish any maintenance or support services
                    with respect to the Software and/or Services.
                </p>

                <br />

                <p className="font-semibold">26. NO WARRANTIES.</p>
                <p>
                    THE RED PARTIES DO NOT WARRANT THAT THE CONTENT DISPLAYED OR TRANSMITTED ON
                    OR THROUGH ANY OF THE SERVICES WILL BE UNINTERRUPTED, OR FREE OF ERRORS,
                    VIRUSES OR OTHER HARMFUL COMPONENTS, AND DO NOT WARRANT THAT ANY OF THE
                    FOREGOING WILL BE CORRECTED. THE RED PARTIES DO NOT WARRANT OR MAKE ANY
                    REPRESENTATIONS REGARDING THE USE OF, OR THE RESULTS FROM THE USE OF, THE
                    SOFTWARE OR SERVICES.
                </p>

                <br />

                <p className="font-semibold">27. HARM TO YOUR DEVICE.</p>
                <p>
                    YOU UNDERSTAND AND AGREE THAT YOU TRANSMIT, DISPLAY OR RECEIVE CONTENT THROUGH
                    THE SERVICE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE SOLELY
                    RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR DEVICE AND COMPUTER
                    SYSTEM) OR LOSS OF DATA THAT RESULTS FROM SUCH CONTENT.
                </p>

                <br />

                <p className="font-semibold">28. LIMITATION OF LIABILITY.</p>
                <p>
                    IN NO EVENT SHALL THE RED PARTIES BE LIABLE, WHETHER BASED IN CONTRACT, TORT
                    (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, FOR ANY LOSSES, LIABILITIES,
                    CLAIMS OR DAMAGES OF ANY KIND, WHETHER DIRECT, INDIRECT, INCIDENTAL,
                    CONSEQUENTIAL, SPECIAL OR PUNITIVE, OR FOR LOSS OF REVENUE OR PROFITS, LOSS OF
                    BUSINESS, OR ANY OTHER DAMAGES, ARISING OUT OF OR IN CONNECTION WITH THE
                    SOFTWARE AND/OR ANY OF THE SERVICES, THIS TERMS OF USE OR THE PERFORMANCE,
                    SUSPENSION, TERMINATION OR BREACH HEREOF, EVEN IF RED OR ANY OTHER RED PARTY
                    HAS BEEN ADVISED OF THE POSSIBILITY THEREOF. THE RED PARTIES SHALL HAVE NO
                    LIABILITY IN CONNECTION WITH OR ARISING FROM THIS TERMS OF USE OR USE OF THE
                    SOFTWARE OR ANY OF THE SERVICES. The foregoing limitations will apply even if
                    the above stated remedy fails of its essential purpose. As some jurisdictions
                    do not allow some of the exclusions or limitations set forth above, some of
                    these exclusions or limitations may not apply to you. In such event the
                    liability of the Red Parties will be limited to the maximum extent possible
                    under applicable law. THESE LIMITATIONS OF LIABILITY ALSO APPLY WITH RESPECT
                    TO DAMAGES INCURRED BY YOU BY REASON OF ANY PRODUCTS OR SERVICES SOLD OR
                    PROVIDED BY THIRD PARTIES OTHER THAN RED AND RECEIVED THROUGH OR ADVERTISED
                    ON ANY OF THE SERVICES.
                </p>

                <br />

                <p className="font-semibold">29. CLAIMS.</p>
                <p>
                    YOU AND RED AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO ANY
                    OF THE SERVICES OR SOFTWARE MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE
                    OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.
                    If you downloaded the Software from the app marketplaces, you further
                    acknowledge that the app marketplaces has no responsibility for addressing any
                    claims relating to the Software or Services or your possession and/or use of
                    the Software or Services, including, but not limited to: (i) product liability
                    claims; (ii) any claim that the Software or Services fail to conform to any
                    applicable legal or regulatory requirement; and (iii) claims arising under
                    consumer protection or similar legislation.
                </p>

                <br />

                <p className="font-semibold">30. BASIS OF THE BARGAIN.</p>
                <p>
                    YOU ACKNOWLEDGE AND AGREE THAT RED HAS OFFERED ITS SOFTWARE AND SERVICES
                    AND SET ITS PRICES IN RELIANCE UPON THE WARRANTY DISCLAIMERS AND THE
                    LIMITATIONS OF LIABILITY SET FORTH HEREIN, THAT THE WARRANTY DISCLAIMERS
                    AND THE LIMITATIONS OF LIABILITY SET FORTH HEREIN REFLECT A REASONABLE
                    AND FAIR ALLOCATION OF RISK BETWEEN YOU AND RED, AND THAT THE WARRANTY
                    DISCLAIMERS AND THE LIMITATIONS OF LIABILITY SET FORTH HEREIN FORM AN
                    ESSENTIAL BASIS OF THE BARGAIN BETWEEN YOU AND RED. RED WOULD NOT BE
                    ABLE TO PROVIDE THE SOFTWARE OR SERVICES TO YOU ON AN ECONOMICALLY REASONABLE
                    BASIS WITHOUT THESE LIMITATIONS.
                </p>

                <br />

                <p className="font-semibold">31. Feedback.</p>
                <p>
                    Any comments, suggestions, or feedback relating to the Software or any of
                    the Services (“Feedback”) submitted to Red shall become the property of Red.
                    Red will have exclusive ownership of all rights to the Feedback. Red will be
                    entitled to use the Feedback for any commercial or other purpose whatsoever,
                    without any compensation to you or any other person. Red will not be required
                    to treat any Feedback as confidential. You agree that you do not acquire any
                    right in or to the Software or any of the Services (or any changes,
                    modifications or corrections thereto) by virtue of any Feedback. You
                    acknowledge that you are responsible for whatever material is submitted by you,
                    including its legality, reliability, appropriateness, originality, and copyright.
                </p>

                <br />

                <p className="font-semibold">32. Export.</p>
                <p>
                    The Software and Services may only be operated, exported or re-exported in
                    compliance with all applicable laws and export regulations of South Korea and
                    the country in which you obtained them. The Software and Services are
                    specifically subject to the South Korean Export Administration Regulations;
                    any diversion contrary to South Korean law is prohibited. You may not export,
                    directly or indirectly, the Software, Services or technical data licensed
                    hereunder or the direct product thereof to any country, individual or entity
                    for which the South Korean Government or any agency thereof, at the time of
                    export, requires an export license or other governmental approval, without
                    first obtaining such license or approval.
                </p>

                <br />

                <p className="font-semibold">32. Export.</p>
                <p>
                    The Software and Services may only be operated, exported or re-exported in
                    compliance with all applicable laws and export regulations of South Korea and
                    the country in which you obtained them. The Software and Services are
                    specifically subject to the South Korean Export Administration Regulations;
                    any diversion contrary to South Korean law is prohibited. You may not export,
                    directly or indirectly, the Software, Services or technical data licensed
                    hereunder or the direct product thereof to any country, individual or entity
                    for which the South Korean Government or any agency thereof, at the time of
                    export, requires an export license or other governmental approval, without
                    first obtaining such license or approval.
                </p>

                <br />

                <p className="font-semibold">33. GENERAL.</p>
                <p>
                    The Software and Services may only be operated, exported or re-exported in
                    compliance with all applicable laws and export regulations of South Korea and
                    the country in which you obtained them. The Software and Services are
                    specifically subject to the South Korean Export Administration Regulations;
                    any diversion contrary to South Korean law is prohibited. You may not export,
                    directly or indirectly, the Software, Services or technical data licensed
                    hereunder or the direct product thereof to any country, individual or entity
                    for which the South Korean Government or any agency thereof, at the time of
                    export, requires an export license or other governmental approval, without
                    first obtaining such license or approval.
                </p>

                <br />

                <p className="font-semibold">33.1 Notices.</p>
                <p>
                    Red may provide you with notices, including those regarding changes to terms
                    and conditions, by email, or postings on the Red website. Notice will be
                    deemed given twenty-four (24) hours after the email is sent, unless Red is
                    notified that the email address is invalid. Notice posted on the Red website
                    is deemed given ten (10) days following the initial posting. Red reserves the
                    right to determine the form and means of providing notifications to our users.
                </p>

                <br />

                <p className="font-semibold">33.2 Amendments.</p>
                <p>
                    Red reserves the right to amend this Terms of Use at any time by publishing
                    the revised Terms of Use on the Red website or by otherwise providing notice
                    of such amendment pursuant to the notice provisions above. The revised Terms
                    of Use shall become effective following the applicable notice period, unless
                    you expressly accept the revised Terms of Use earlier by clicking on the
                    accept button. Your express acceptance or continued use of the Software or
                    Services after the applicable notice period shall constitute your acceptance
                    to be bound by the terms and conditions of the revised Terms of Use. You can
                    find the latest version of this Terms of Use at {" "}
                    <a
                        href="/terms"
                        target="_blank"
                        rel="noreferrer"
                        className="text-red-500"
                    >
                        https://redvideochat.live/terms
                    </a>
                </p>

                <br />

                <p className="font-semibold">33.3 International Users.</p>
                <p>
                    The Software and Services are hosted in South Korea and by using the Software
                    and/or any of the Services, if you are located in the European Union, Asia or
                    any other region with laws or regulations governing personal data collection,
                    use and disclosure that differ from South Korean laws, then you understand and
                    consent to the processing of personal information in South Korea.
                </p>

                <br />

                <p className="font-semibold">33.4 Ability to Contract.</p>
                <p>
                    You hereby affirm that you are fully able and competent to enter into the
                    terms, conditions, obligations, affirmations, representations and warranties
                    set forth in this Terms of Use, and to abide by and comply with the terms and
                    conditions of this Terms of Use.
                </p>

                <br />

                <p className="font-semibold">33.5 Entire Agreement.</p>
                <p>
                    This Terms of Use represents the complete agreement concerning the matters
                    covered and, except as set forth under Amendments above, may be amended only
                    by a writing executed by both parties. If any provision of this Terms of Use
                    is held to be unenforceable, such provision shall be modified only to the
                    extent necessary to make it enforceable and shall not affect the
                    enforceability or validity of the remaining provisions, which shall remain
                    in full force and effect.
                </p>

                <br />

                <p className="font-semibold">33.6 Waiver.</p>
                <p>
                    The failure of Red to exercise or enforce any right or provision of this
                    Terms of Use will not constitute a waiver of such right or provision.
                    Any waiver of any provision of this Terms of Use will be effective only
                    if in writing and signed by Red.
                </p>

                <br />

                <p className="font-semibold">33.7 Headings.</p>
                <p>
                    The heading references herein are for convenience purposes only, do not
                    constitute a part of this Terms of Use, and will not be deemed to limit or
                    affect any of the provisions hereof.
                </p>

                <br />

                <p className="font-semibold">33.8 Governing Law and Venue.</p>
                <p>
                    This Terms of Use is governed by the laws of South Korea as such laws are
                    applied to agreements entered into and to be performed entirely within
                    South Korea, and by the laws of South Korea. The United Nations Convention
                    on Contracts for the International Sale of Goods (1980) is hereby excluded
                    in its entirety from application to this Terms of Use. You agree that the
                    Services shall be deemed solely based in South Korea, and that the Services
                    do not give rise to personal jurisdiction over Red, either specific or
                    general, in jurisdictions other than South Korea. You further agree that the
                    courts located in South Korea shall have exclusive jurisdiction and venue
                    over all controversies and disputes in connection herewith, including but
                    not limited to any controversies or disputes arising from or related to the
                    Software, Services, Content or this Terms of Use. You agree not to commence
                    or prosecute any action against any Red Party other than in courts located
                    in South Korea, and you hereby consent to, and waive all defenses of lack of
                    personal jurisdiction and forum non convenience with respect to, venue and
                    jurisdiction in such courts.
                </p>

                <br />

                <p className="font-semibold">33.9 Injunctive Relief.</p>
                <p>
                    You acknowledge that the obligations made hereunder to Red are of a unique
                    and irreplaceable nature, the loss of which shall irreparably harm Red and
                    which cannot be replaced by monetary damages alone so that Red shall be
                    entitled to injunctive or other equitable relief (without the obligations of
                    posting any bond or surety) in the event of any breach or anticipatory breach
                    by you. You irrevocably waive all rights to seek injunctive or other equitable
                    relief.
                </p>

                <br />

                <p className="font-semibold">33.10 Third Party Beneficiaries and Agreements.</p>
                <p>
                    If you downloaded the Software from the app marketplaces, you acknowledge and
                    agree that the app marketplaces are third party beneficiaries of this License
                    Agreement, and that, upon your acceptance of the terms and conditions of this
                    Terms of Use, the app marketplaces will have the right (and will be deemed to
                    have accepted the right) to enforce this Terms of Use against you as a third
                    party beneficiary hereof. You agree to comply with, and your license to use
                    the Software and Services is conditioned upon your compliance with, all
                    applicable third-party terms of agreement, including those of any Application
                    Store, as may be applicable, when using the Software and/or Services.
                </p>

                <br />

                <p className="font-semibold">33.11 Privacy Policy.</p>
                <p>
                    You can find the latest version of Red's Privacy Policy at{" "}
                    <a
                        href="/privacy"
                        target="_blank"
                        rel="noreferrer"
                        className="text-red-500"
                    >
                        https://redvideochat.live/privacy
                    </a>
                </p>

                <br />

                <p className="font-semibold">33.12 Mobile Alerts and Optout.</p>
                <p>
                    Red may use carrier distributed mobile messaging (SMS) to verify ownership
                    of a registered mobile phone number.
                </p>

            </div>

            <br /><br />
        </div>
    );
}